<template>
  <div id="app">
    <div class="wrapper">
      <Sidebar></Sidebar>
      <div class="contentwrapper">
        <Header></Header>

        <div class="content">
          <router-view/>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Header from "@/components/Header.vue";
import Sidebar from "@/components/Sidebar.vue";

export default {
  components: {
    Header,
    Sidebar
  }
};
</script>


<style lang="scss">
@import "assets/css/MyFontsWebfontsKit.css";
@import "assets/css/reset.css";

/*-----------------------------------*\
  _variables
\*-----------------------------------*/

$lighterGrey: #f1efe8;
$lightGrey: #cdccc7;
$white: #fff;
$grey: #a19a89;
$darkGrey: darken($grey, 20%);
$gold: #eec60a;

$top_padding: 240px;

/*-----------------------------------*\
  _general
\*-----------------------------------*/

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  font-size: 1.03em;
}

body {
  background: $lightGrey;
  font-family: RotisSansSerif;
  font-weight: normal;
  font-style: normal;
}

#app {
  height: 100%;
}

.wrapper {
  margin: 0 auto;
  width: 800px;
  height: 100%;
}

.news a {
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
}

a {
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

strong {
  font-weight: bold;
}

.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

/*-----------------------------------*\
  _sidebar
\*-----------------------------------*/

.sidebar {
  position: fixed;
  padding-left: 40px;
  padding-top: $top_padding; // ???
  width: 240px;
  height: 100%;
  background: $darkGrey;

  nav li {
    margin-bottom: 1em;
    list-style-type: none;

    a {
      color: $white;
      font-size: 0.95em;
      font-weight: bold;

      &:hover,
      &.active {
        color: $gold;
        text-decoration: none;
      }
    }
  }

  footer {
    position: absolute;
    width: 100%;
    bottom: 30px;
    color: lighten($grey, 10%);
    font-size: 0.8em;
    line-height: 1.4em;

    p {
      margin-bottom: 10px;
    }

    .companyName {
      font-weight: bold;
      font-size: 1.2em;
    }

    a {
      color: inherit;

      :hover {
        text-decoration: underline;
      }
    }
  }
}

/*-----------------------------------*\
  _content
\*-----------------------------------*/

.contentwrapper {
  margin-left: 240px;
  width: 560px; /* 800 - 240 = 560 */
  background: $white;
  height: 100%;
  clear: both;
  position: relative;

  header {
    float: right;
    margin-top: 20px;

    h1 {
      margin-right: 150px;
      color: darken($grey, 20%);
      font-size: 1.2em;
    }

    #logo {
      float: right;
      margin-top: 40px;
      clear: both;
    }
  }
}

.content {
  padding-right: 40px;
  padding-left: 20px;
  color: darken($grey, 20%);
  padding-top: $top_padding;
  padding-bottom: 30px;
  background: $white;
}

section {
  display: block;

  &:not(:last-child) {
    padding-bottom: 20px;
    margin-bottom: 40px;
  }

  p,
  li {
    font-size: 0.92em;
  }

  p {
    line-height: 1.4em;
    margin-bottom: 20px;
  }

  h2 {
    display: block;
    margin-bottom: 2em;
    color: darken($gold, 1%);
    font-size: 1.2em;
  }

  h3 {
    margin-bottom: 10px;
  }

  a {
    color: inherit;

    &:hover {
      text-decoration: underline;
    }
    h3 {
      display: block;
      font-weight: bold;
      margin-bottom: 2em;
    }
  }

  img.centered {
    display: block;
    margin: 20px auto;
  }

  img.floatright {
    float: right;
    margin-left: 20px;
    margin-top: 5px;
    margin-bottom: 20px;
  }
}

.news li {
  margin-bottom: 10px;
}

.arbeitsgebiete {
  ul {
    margin-left: 10px;
    margin-bottom: 40px;
  }

  li {
    line-height: 1.2em;
    font-size: 0.9em;

    &:before {
      content: "-";
      margin-right: 10px;
    }
  }

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      color: $gold;
    }
  }
}

.referenzen,
.aktuelles {
  .referenzInfo {
    margin-bottom: 80px;
  }

  ul {
    margin-bottom: 20px;
  }

  li {
    line-height: 1.2em;
    font-size: 0.9em;
    text-indent: -1em;
    list-style-position: inside;
    padding-left: 20px;
  }
}

.impressum,
.kontaktInfo {
  p {
    margin-bottom: 20px;
    font-size: 0.9em;
  }

  a {
    color: inherit;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>

